<template>
  <b-modal id="attach-new-files-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`">
    <template #modal-title>
      <h5 class="modal-title adp-h2 adp-h2__modal">{{$t('idp.cm_attach_files')}}</h5>
    </template>
    <div class="adp-p adp-p__grey" style="margin: -1.5rem 0 1.5rem">
      {{ learningActivityTitle }}
    </div>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt="" @click="close"></span>
    </template>
    <template>
      <div v-for="file in filesArray" :key="file.id" v-if="filesArray.length">
        <div class="adp-modal-files-block">
          <div class="adp-modal-files-block__icons">
            <span class="adp-modal-files-block__icons rectangle"><img src="/images/rectangle.svg" alt=""></span>
            <span class="adp-modal-files-block__icons paperclip"><img src="/images/paperclip.svg" alt=""></span>
          </div>
          <div class="adp-modal-files-block__title">
            <div style="overflow: hidden; text-overflow: ellipsis; max-width: 400px">{{ file.name }}</div>
          </div>
          <div class="adp-modal-files-block__trash" @click="deleteFile(file)">
            <img src="/images/trash.svg" alt="">
          </div>
        </div>
      </div>

      <div class="adp-modal-input-file-block">
        <div class="adp-p adp-p__grey" style="margin: 2rem 0 0.7rem">Файл</div>
        <b-form-file multiple v-model="inputFiles" @input="addFilesToArray($event)"
          :placeholder="$t('modal.files_input_placeholder')"
          :drop-placeholder="$t('modal.drop_placeholder')"
        />
      </div>
    </template>
    <template #modal-footer>
      <button class="btn btn-primary adp-btn adp-btn__large" style="margin-left: auto" @click="save()">
        {{ $t('voc.save') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import api from "../../api";

export default {
  name: "AttachNewFilesModal",
  components: {},
  props: {
    learningActivityTitle: {
      type: String,
      required: true,
    },
    learningActivityId: {
      type: Number,
      required: true,
    },
    viewerPernumber: {
      type: Number,
      required: true
    },
  },
  data: () => {
    return {
      filesArray: [],
      inputFiles: null,
      currentRole: '',
    }
  },
  methods: {
    deleteFile(file) {
      this.filesArray = this.filesArray.filter((item) => item !== file);
      this.inputFiles = null;
    },
    save() {
      if (this.filesArray.length) {
        this.saveFiles()
      } else {
        this.$bvModal.hide('attach-new-files-modal');
        this.$bvModal.hide('files-list-modal');
        this.$bvModal.show('files-list-modal');
      }
    },
    saveFiles() {
      const isSizeCorrect = this.isFilesSizeCorrect();
      if (isSizeCorrect) {
        const formData = new FormData();
        Array.from(this.filesArray.keys())
          .map(id => {
            formData.append(String(id), this.filesArray[id], this.filesArray[id].name);
          });
        formData.append('user_pernumber', String(this.viewerPernumber));
        formData.append('learning_activity_id', String(this.learningActivityId));
        formData.append('role', String(this.currentRole));

        api.uploadFiles(formData);
        this.$emit('files-attached');
        this.$bvModal.hide('attach-new-files-modal');
        this.$bvModal.hide('files-list-modal');
        this.$bvModal.show('files-list-modal');
      } else {
        this.$toasts.error(this.$t('modal.big_file_error'), {
          duration: 700000,
        });
      }
    },
    close() {
      this.filesArray = [];
    },
    isFilesSizeCorrect() {
      let isSizeNormal = true;
      this.filesArray.forEach((file) => {
        if (file.size > 10000000) {
          isSizeNormal = false;
        }
      })
      return isSizeNormal;
    },
    addFilesToArray(files) {
      this.filesArray = [...this.filesArray, ...files];
    }
  },
  mounted() {
    this.currentRole = window.IDP.role;

    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      this.close();
    })
  }
}
</script>

<style scoped>

</style>
